import "./Checkbox.scss";

import { ChangeEvent, FC } from "react";
import EllipsisTooltip from "../EllipsisTooltip/EllipsisTooltip";


export type CheckboxProps = {
    id?: string;
    label?: string;
    leftLabel?: string;
    name: string;
    checked?: boolean;
    value: string;
    disabled?: boolean;
    onChange?: (event: ChangeEvent<HTMLInputElement>) => typeof event;
    onBlur?: (event: ChangeEvent<HTMLInputElement>) => typeof event;
    className?: string;
    readOnly?: boolean;
    useEllipsis?: boolean;
};

const Checkbox: FC<CheckboxProps> = ({ id, name, label, checked, onChange, value, onBlur, disabled, readOnly, leftLabel, className, useEllipsis }) => {

    return (
        <div className={`form_control form_control__checkbox ${className}`}>
            {leftLabel &&
                <label className="checkbox__label left" htmlFor={id}>{leftLabel}</label>
            }
            <input
                id={id}
                className="checkbox"
                checked={checked ?? !!value}
                name={name}
                type="checkbox"
                onChange={(e) => {
                    if (!readOnly && onChange)
                        return onChange(e)
                }}
                value={value}
                onBlur={onBlur}
                disabled={disabled}
                readOnly={readOnly}
            />
            {label && (
                <label className="checkbox__label" htmlFor={id}>
                    {useEllipsis ? <EllipsisTooltip text={label} /> : label}
                </label>
            )}
        </div>
    );
};
export default Checkbox;
